import { isUndefined, isEqual } from 'lodash'

export default class VariationListingFiltersModel {
  uriWithoutOffset = ''
  filterQueryStringVar = ''
  activeFilters = []
  isTopLevelCategory = false
  currentPageNumber = null
  urlLang = ''
  activeAttributeFiltersString = ''

  constructor (uriWithoutOffset, filterQueryStringVar, activeFilters, isTopLevelCategory, currentPageNumber, urlLang, activeAttributeFiltersString) {
    this.uriWithoutOffset = uriWithoutOffset
    this.filterQueryStringVar = filterQueryStringVar
    this.activeFilters = activeFilters
    this.isTopLevelCategory = isTopLevelCategory
    this.currentPageNumber = currentPageNumber
    this.urlLang = urlLang
    this.activeAttributeFiltersString = activeAttributeFiltersString
  }

  static isTextRangeGroup (group) {
    if (isUndefined(group.variations.chunks) && group.variations.length > 0) {
      return false
    }
    return (group.variationDisplayType === 'text-range-per-count' || group.variationDisplayType === 'text-range-per-value') && group.variations.chunks.length > 0
  }

  static inactivateTextRageFilter (entry, activeFilters) {
    const chunkValueIds = entry.chunkValueIds

    activeFilters = activeFilters.filter(e => {
      return !chunkValueIds.includes(e)
    })

    return activeFilters
  }

  static inactivateBaseFilter (entry, activeFilters) {
    const variationId = entry.variationId

    activeFilters = activeFilters.filter(e => {
      return Number(e) !== Number(variationId)
    })

    return activeFilters
  }

  removeQueryString (
    group,
    entry,
    activeFilters
  ) {
    let str = this.activeAttributeFiltersString

    if (this.activeFilters === null) {
      return ''
    }

    if (VariationListingFiltersModel.isTextRangeGroup(group)) {
      activeFilters = VariationListingFiltersModel.inactivateTextRageFilter(entry, this.activeFilters)
    } else {
      activeFilters = VariationListingFiltersModel.inactivateBaseFilter(entry, this.activeFilters)
    }

    if (activeFilters.length > 0) {
      if (this.activeAttributeFiltersString !== '') {
        str += '&'
      }
      str += `${this.filterQueryStringVar}[]=${activeFilters.join(`&${this.filterQueryStringVar}[]=`)}`
    }

    return (str !== '') ? `?${str}` : '/' + this.urlLang + this.uriWithoutOffset
  }

  addQueryString (
    group,
    entry,
    activeFilters
  ) {
    let str = this.activeAttributeFiltersString

    if (activeFilters === null) {
      return ''
    }

    if (activeFilters.length > 0) {
      if (this.activeAttributeFiltersString !== '') {
        str += '&'
      }
      str += `${this.filterQueryStringVar}[]=${activeFilters.join(`&${this.filterQueryStringVar}[]=`)}`
    }

    return `?${str}`
  }

  createLinkQueryStringForRangeGroup (group, entry, isFilterUsed) {
    let finalString = ''
    const activeFilters = [...this.activeFilters]

    let stringWithAllIdsIncluded = ''
    for (const variationId of entry.chunkValueIds) {
      stringWithAllIdsIncluded += '&' + this.filterQueryStringVar + '[]=' + variationId
    }

    if (isFilterUsed) {
      finalString = this.removeQueryString(group, entry, activeFilters)
      if (!isEqual(activeFilters.sort(), entry.chunkValueIds.sort())) {
        return finalString
      }

      if (this.isTopLevelCategory) {
        return finalString + '/1'
      }

      return '/' + this.urlLang + this.uriWithoutOffset
    } else {
      if (this.activeFilters === null) {
        return this.addQueryString(group, entry, activeFilters) + '?' + stringWithAllIdsIncluded
      }
      return this.addQueryString(group, entry, activeFilters) + stringWithAllIdsIncluded
    }
  }

  createLinkQueryStringForBaseGroup (group, entry, isFilterUsed) {
    let finalString = ''
    const activeFilters = [...this.activeFilters]

    if (isFilterUsed) {
      finalString = this.removeQueryString(group, entry, activeFilters)
      if (this.activeFilters.length === 1) {
        return this.queryStringForLastActiveFilter()
      }
    } else {
      finalString = this.addQueryString(group, entry, activeFilters) + '&' + this.filterQueryStringVar + '[]=' + entry.variationId

      if (this.activeFilters === null) {
        finalString = this.addQueryString(group, entry, activeFilters) + '?' + this.filterQueryStringVar + '[]=' + entry.variationId
      }
    }

    if (this.isTopLevelCategory) {
      return '/' + this.urlLang + this.uriWithoutOffset + '/1' + finalString
    }

    return '/' + this.urlLang + this.uriWithoutOffset + finalString
  }

  createLinkQueryStringFinal (group, entry, isFilterUsed) {
    if (VariationListingFiltersModel.isTextRangeGroup(group)) {
      return this.createLinkQueryStringForRangeGroup(group, entry, isFilterUsed)
    } else {
      return this.createLinkQueryStringForBaseGroup(group, entry, isFilterUsed)
    }
  }

  queryStringForLastActiveFilter () {
    const firstEntryString = '/' + this.urlLang + this.uriWithoutOffset
    if (this.isTopLevelCategory) {
      if (this.activeAttributeFiltersString !== '') {
        return firstEntryString + '/1' + '?' + this.activeAttributeFiltersString
      }
      return firstEntryString + '/1'
    }

    if (this.activeAttributeFiltersString !== '') {
      return firstEntryString + '?' + this.activeAttributeFiltersString
    }

    return firstEntryString
  }
}
